export const LabelQa = {
    copyButton: 'copy-button',
    closeButton: 'close-button',
    mainButton: 'main-button',
};
